interface MedicalSpecialtyTagV2Props {
  name: string;
  className?: string;
  textClassName?: string;
}

export function MedicalSpecialtyTagV2({
  name,
  className = '',
  textClassName = '',
}: MedicalSpecialtyTagV2Props) {
  return (
    <div
      className={`flex min-w-[30px] shrink-0 items-center justify-center gap-[10px] rounded-full px-1.5 py-0.5 ${className}`}
      style={{
        background:
          'linear-gradient(92deg, #3E57E2 6.05%, #B133FF 43.63%, #FF5DCA 100%)',
      }}
    >
      <p
        className={`relative shrink-0 text-xs font-medium leading-4 text-white ${textClassName}`}
        title={name}
      >
        {name}
      </p>
    </div>
  );
}
